import { useState, useEffect } from "react";
import { MenuUnfoldOutlined, MenuFoldOutlined, LogoutOutlined } from "@ant-design/icons";
import { Layout, Menu, Switch } from "antd";
const { Header, Sider, Content } = Layout;
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Logo from "../../Assets/Images/Left.png";
import LogoSmall from "../../Assets/Images/favicon.png";
import { logOut } from "../../Utils/UserSlice";
import { handledarkMode } from "../Elements/DarkModeAction";
import { Footer } from "antd/es/layout/layout";

const SidebarLayout = ({ items, NavItems, DefaultRoute, title }) => {
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(true);
  const [showMenuIcon, setShowMenuIcon] = useState(true);
  const navigate = useNavigate();
  const [selectedKey, setSelectedKey] = useState(localStorage.getItem("selectedKey",3) || "3");
  const rs_message = useSelector((state) => state.footer.message);
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;

  const switchDarkMode = () => {
    isdarkMode ? dispatch(handledarkMode(false)) : dispatch(handledarkMode(true));
  };

  useEffect(() => {
    document.body.style.backgroundColor = isdarkMode ? "#292c35" : "#fff";
  }, [isdarkMode]);
  console.log(selectedKey)

  const handleMenuClick = (e) => {
    const clickedKey = e.key;
    setSelectedKey(clickedKey);
    console.log(clickedKey);
    // localStorage.setItem("selectedKey", clickedKey);

    const selectedItem = NavItems.find((item) => item.id === clickedKey);
    if (selectedItem) {
      navigate(selectedItem.path);
    }
  };

  const handleLogout = () => {
    navigate("/login");
    dispatch(logOut());
    localStorage.removeItem("selectedKey");
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 495) {
        setShowMenuIcon(false);
        setCollapsed(true);
      } else {
        setShowMenuIcon(true);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Layout className={`dark ${isdarkMode ? 'darkmode' : 'whitemode'}`}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className="h-screen z-50 md:w-64 sm:w-32 w-16 pt-14"
        style={{
          position: "sticky",
          top: 0,
          left: 0,
          bottom: 0,
          paddingRight: 4,
          paddingLeft: 4,
          background: isdarkMode ? "#2b4162 linear-gradient(315deg, #2b4162 0%, #12100e 74%)" : "rgba(30, 58, 138, 1)",
        }}
        onMouseEnter={() => setCollapsed(false)}
        onMouseLeave={() => setCollapsed(true)}
      >
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[selectedKey]}
          items={items}
          className="bg-transparent font-bold z-50"
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout className="site-layout dark">
        <Header className={`sticky top-0 w-full bg-blue-900 z-10 shadow-md px-0 text-white ${isdarkMode ? 'headermode' : 'whitemode'} py-0 h-12`}>
          {/* {showMenuIcon && (
            <i
              onClick={() => setCollapsed(!collapsed)}
              className="cursor-pointer text-xl absolute top-2 left-2"
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </i>
          )} */}
          <div className="w-full flex justify-between items-center ml-0 ">
            <img className="w-48 h-8" src={Logo} alt="logo" />
            <p className="text-lg font-bold mt-2">{title || 'Electrical'}</p>
            <div className="flex mr-5 gap-5"> 
              <Switch checked={isdarkMode} onChange={switchDarkMode} checkedChildren="Dark" unCheckedChildren="Light" />
              <LogoutOutlined className="text-lg cursor-pointer" onClick={handleLogout} />

            </div>
          </div>
        </Header>
        <Content className="h-[calc(100vh-120px)]">
          <div className="p-6 bg-slate-100 h-full overflow-auto dark">
            <Routes>
              <Route path="/" element={DefaultRoute} />
            </Routes>
            <Outlet />
          </div>
        </Content>
        <div className="min-h-2 bg-blue-900  ">
          <p className="font-mono text-sm text-white">{rs_message}</p>
        </div>
      </Layout>
    </Layout>
  );
};

export default SidebarLayout;



